import { CountryType } from '../../../../models/country-type';
import client from '../../client-unauthenticated';

const accountCountries = async (): Promise<CountryType[]> => {
  const {
    data: { countries },
  } = await client.get<{ countries: CountryType[] }>('/account/countries', {
    params: { provider: 0 },
  });

  return countries;
};

export default accountCountries;
